import {Component} from 'react';
import favoriteQuestionOptions from './datasets/favorite_question_options';
import initializeErrorArray from '../admin/objects/initialize_error_array';
import getCurrentDateTime from '../../objects/CommonUse/get_current_date_time';
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';
import editPortalEntryData from './objects/edit_portal_entry_data';
import updateErrorArr from '../../objects/CommonUse/update_error_arr';
import PasswordChecklist from "react-password-checklist";
import setTempTokenForFetch from '../../objects/CommonUse/set_temp_token_for_fetch';
import determineAccountNbr from '../../objects/CommonUse/determine_account_nbr';
import DropDownOptionCard from '../shared-components/drop_down_option_card';


function GetURLParms(paramName) {
  const params = new URLSearchParams(window.location.search);
  return params.get(paramName);
}

class CreatePortal extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.state={
            subProcess: "createPortal",
            favoriteQuestionArr: favoriteQuestionOptions,
            environment: Config.dataURL.currentEnv,
            waitState: true,
            accountListLoaded: false,
            className: "",
            nbrPlayers: '',
            gradeLevel: 'none',
            username: '',
            password: '',
            confirmPassword: '',
            securityQuestion: 'none',
            securityAnswer: '',
            accountNbr: "",
            rerender: false,
        }    
        this.errorArray = initializeErrorArray(9);
        this.dataValidSw = true;
        this.password = "";
        this.confirmPassword = "";
        this.accountList = [];
        this.nbrPrimary = 1;
        this.errorMsg = "";
}

    componentDidMount(){
        //  get the account type (either parent or teacher) based on the route 
        this.determineUserRole();
        if (this.primaryRole !== "student"){
            this.getAccountList();
        }
    }

    determineUserRole(){
        switch (this.props.selected){
            case "createTeacherPortal":
                this.primaryRole = "teacher";
                break;
            case "createParentPortal":
                this.primaryRole = "parent";
                break;
            case "createStudentPortal":
                //  teacher's link will be playmoneytrain.com/create-student-portal?accountNbr=44821 
                this.primaryRole = "student";
                const accountNbr = GetURLParms("accountNbr");
                this.setState({ accountNbr: accountNbr, waitState: false });
                break;
            default:
                break;
        }
    }


    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({
            [name]: value
        });
    };
 
       
    render() {
        let titleRole = "";
        switch (this.primaryRole){
            case "teacher":
                titleRole = "Teacher";
                break;
            case "parent":
                titleRole = "Parent";
                break;
            case "student":
                titleRole = "Player";
                break;
            default: 
                break;
        }

        const favoriteQuestions = this.state.favoriteQuestionArr.map((optionsList,index) =>
            <DropDownOptionCard options={optionsList} key={index} />
            );

    return <>
       
            {this.state.waitState   ? 
              <WaitTimeSpinner/>
            :
                                      
           <form ref={this.formRef} className="portal-form px-2 pb-2" id="registerForm">
               <h5 className="form-header">
                    {this.primaryRole === "teacher" || this.primaryRole === "parent"  ?
                        <span>Create {titleRole} Portal</span>
                    :
                        <span>Create Your Sign-on</span>
                    }
                    <img className="x-picture-size" src={'./assets/x-close.png'} alt="X"
                        onClick={() => this.onClose()} />
                </h5>
                <ul className="bulleted-list">
                    <li>Class Code will be displayed on the For Parents/Teachers 
                        "Players Settings" page.
                    </li>
                    <li>User name doesn't need to be your name just make sure
                        it is something you remember.     </li>
                    <li>All entry fields are case sensitive.</li>
                    <li>Remember your password and security question answer!!!</li>
                </ul>
                <h6 className="text-center">
                   <b>Class Code: </b> {this.state.accountNbr} 
                </h6>
                <p className="mt-2">Please complete all fields on this form and then click 
                   'Submit'.</p>
                
                {this.primaryRole === "teacher"  ?
                    <div className="mt-2">
                    <label className="font-weight-bold" htmlFor="className">
                            Name of Class: &nbsp;&nbsp;</label>
                        <span className={this.errorArray[8].textType}>
                            &nbsp;{this.errorArray[8].message}</span>
                        <input
                            type="text"
                            className="form-control"
                            name="className"
                            placeholder="Enter the Name of the Class"
                            value={this.state.className}
                            onChange={this.handleChange}>
                        </input>
                    </div> 
                :
                    null
                }

                {this.primaryRole === "teacher" || this.primaryRole === "parent"  ?
                    <>
                    <div className="mt-2">
                    <label className="font-weight-bold" htmlFor="nbrPlayers">
                            Nbr of Player Ids: &nbsp;&nbsp;</label>
                        <input
                            className="col-small"
                            type="text"
                            name="nbrPlayers"
                            value={this.state.nbrPlayers}
                            onChange={this.handleChange}>
                        </input>
                        <span className={this.errorArray[0].textType}>
                            &nbsp;{this.errorArray[0].message}</span>
                    </div> 
        
                    <div className="mt-2">
                    <label className="font-weight-bold" htmlFor="gradeLevel">Player Grade Level:&nbsp;&nbsp;</label>
                    <select 
                        className="btn btn-sm btn-outline-secondary dropdown-toggle" id="gradeLevel"
                        value={this.state.gradeLevel} name="gradeLevel" onChange={this.handleChange}>
                            <option value="none">no grade level slctd</option>
                            <option value="Elementary">Elementary School</option>
                            <option value="MiddleSchool">Middle or Junior High School</option>
                            <option value="HighSchool">High School</option>
                    </select>
                    <span className={this.errorArray[1].textType}>
                            &nbsp;{this.errorArray[1].message}</span>
                    </div>
                    </>
                :
                    null
                }
               
                <div className="form-group text-left mt-2">
                    <label className="font-weight-bold">New Username: &nbsp;&nbsp;</label>
                    <input
                        type="text"
                        name="username"
                        placeholder="Preferred username"
                        value={this.state.username}
                        onChange={this.handleChange}>
                    </input>
                     <span className={this.errorArray[2].textType}>
                          &nbsp;{this.errorArray[2].message}</span>
                </div>
           
                <div className="form-group text-left mb-0">
                    <label className="font-weight-bold">New Password: &nbsp;&nbsp;</label>
                    <input
                        type="password"
                        className="col-small"
                        name="password"
                        placeholder="Password"
                        value={this.state.password}
                        onChange={this.handleChange}>
                    </input>
                    <span className={this.errorArray[3].textType}>
                          &nbsp;{this.errorArray[3].message}</span>
                </div>
                <div className="form-group text-left mb-0">
                    <label className="font-weight-bold">Confirm Password: &nbsp;&nbsp;</label>
                    <input
                        type="password"
                        className="col-small"
                        name="confirmPassword"
                        placeholder=" Confirm Password"
                        value={this.state.confirmPassword}
                        onChange={this.handleChange}>
                    </input>
                    <span className={this.errorArray[4].textType}>
                          &nbsp;{this.errorArray[4].message}</span>
                </div> 
                <PasswordChecklist
                        rules={["minLength","specialChar",
                            "match"]}
                        minLength={8}
                        value={this.state.password}
                        valueAgain={this.state.confirmPassword}
                    />
                <div className="mt-3">
                    <label className="font-weight-bold">Security Question (used for password reset): &nbsp;&nbsp;</label>
                    <select 
                       className="btn btn-sm btn-outline-secondary dropdown-toggle" id="secQues"
                        value={this.state.securityQuestion} name="securityQuestion" 
                        onChange={this.handleChange}>                      
                            {favoriteQuestions}
                    </select>
                    <span className={this.errorArray[5].textType}>
                          &nbsp;{this.errorArray[5].message}</span>
                </div>
                <div className="form-group text-left mt-2">
                    <label className="font-weight-bold">
                        Security Answer: &nbsp;&nbsp;</label>
                     <span className={this.errorArray[6].textType}>
                          &nbsp;{this.errorArray[6].message}</span>
                    <input
                        type="text"
                        className="form-control"
                        name="securityAnswer"
                        placeholder="Security Answer"
                        value={this.state.securityAnswer}
                        onChange={this.handleChange}>
                    </input>
                    <div>(must be at least 6 characters long)</div>
                   
                </div>
                {this.primaryRole === "teacher" ||  this.primaryRole === "parent" ?
                    <div className="form-group text-left mt-2">
                        <label className="font-weight-bold">
                            Email Address (optional): &nbsp;&nbsp;</label>
                        <span className={this.errorArray[7].textType}>
                            &nbsp;{this.errorArray[7].message}</span>
                        <input
                            type="text"
                            className="form-control"
                            name="emailAddress"
                            placeholder="Email Address"
                            value={this.state.emailAddress}
                            onChange={this.handleChange}>
                        </input>
                        
                    </div>
                :
                    null
                }
                <div className="form-group my-2 text-right">
                    <span className="text-danger text-left font-weight-bold">{this.errorMessage}
                        &nbsp;&nbsp;
                    </span>
                    <button type="button" className="btn btn-primary" 
                        onClick={()=>this.processInputValues()}>Submit</button>
                    <button type="button" className="ml-2 btn btn-primary" 
                        onClick={()=>this.onClose()}>Close</button>
                </div>
                           
            </form>
        }
        
        </>
    }

    async processInputValues(){
        this.errorMsg = "";
        this.setState({waitState: true});
        this.errorArray = initializeErrorArray(9);
        this.errorsFound = editPortalEntryData(this.primaryRole, this.state.className, this.state.nbrPlayers, 
            this.state.gradeLevel, this.state.username, this.state.password, this.state.confirmPassword,
            this.state.securityQuestion, this.state.securityAnswer, 
            this.state.emailAddress, this.errorArray  );
        if (this.errorsFound === false){
            await this.getLogin();
            if (this.userFound === true){
                this.errorsFound = true;
                const errorMsg = "Username already exists, change username and resubmit";
                updateErrorArr(2, errorMsg, this.errorArray);
            }
        }
        if (this.errorsFound === true){
            this.errorMessage = "Please correct errors and resubmit."
            this.setState({waitState: false});
        }else{
            this.formatRqstdUsersArr();
            //  probably should make both of the following 'await'...
            if (this.primaryRole !== "student"){
                await this.saveAccount();
            }
            await this.saveLoginUser();
            const closeObj={userName: this.state.username, password: this.state.password};
            this.props.registerComplete(closeObj);
        }
    }

    onClose(){
        this.props.registerComplete();
    }

    formatRqstdUsersArr(){
        const dateObj =  getCurrentDateTime(); 
        this.rqstdUsersArr = [{role: this.primaryRole, dateRqstd: dateObj.date, nbrUsersRqstd: this.nbrPrimary},
            {role: "player", dateRqstd: dateObj.date, nbrUsersRqstd: this.state.nbrPlayers}];
        
    }
    
    setSessionStorage(){
        sessionStorage.setItem('username', this.username);
        sessionStorage.setItem('userRole', this.role);
        sessionStorage.setItem('userAccountNbr', this.state.accountNbr);
        sessionStorage.setItem('defaultUserAccount', this.loginInfor.accountNbr);
        this.props.setInfoRedux(this.role, "playerRole")
    }
    
    getAccountList(){
        let headers = setTempTokenForFetch(this.username, this.password);
        const funcName = "loadAccountList";
        const urlParm = "?tokenType=TempToken";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch(uri,
            {method:'GET',
            headers: headers,
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                            this.accountList = output.body;
                            const accountNbr = determineAccountNbr(this.accountList);
                            this.setState({accountListLoaded: true, waitState: false, accountNbr: accountNbr});
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message};
                            this.props.processError(errorObj);
                        }
                    });
                };
            })
    }

   
  async getLogin () {
        let headers = setTempTokenForFetch(this.username, this.password);
        const funcName = "loginChk";
        const rqstType = "UserOnly";
        const urlParm = "?rqstType=" + rqstType;
        const uri = buildUrl(this.state.environment, funcName, urlParm);

        try {
            const response = await fetch(uri, {
                method: 'GET',
                headers: headers
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            const output = typeof data === "string" ? JSON.parse(data) : data;
            const statusCode = output.statusCode;
            if (statusCode === 200) {
                this.loginInfo = output.body;
                this.userFound = this.loginInfo.result === "Username Found";
            } else {
                const errorObj = {
                    function: funcName,
                    subProcess: this.state.subProcess,
                    status: statusCode,
                    message: output.body.message

                };
                this.props.processError(errorObj);
            }

            return output; // important if caller needs result

        } catch (error) {
            const errorObj = {
                function: funcName,
                subProcess: this.state.subProcess,
                status: 500,
                message: error.message
            };

            this.props.processError(errorObj);
            throw error; // allows caller to catch it
        }
    };
  
async saveAccount() {
      
    try {
        const currentDateTime = getCurrentDateTime();
        let headers = setTempTokenForFetch(this.username, this.password);
        const accountObj = {
            accountNbr: this.state.accountNbr.toString(),
            className: this.state.className,
            accountOwnerArr: [{username: this.state.username, dateUpdated: currentDateTime.date}],
            accountOwner: this.state.username,
            gradeLevel: this.state.gradeLevel,
            rqstdUsersArr: this.rqstdUsersArr,
            emailAddress: this.state.emailAddress
        };

        const funcName = "updateAccount";
        const urlParm = "?tokenType=TempToken";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        const response = await fetch(uri, {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(accountObj)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const output = typeof data === "string" ? JSON.parse(data) : data;
        const statusCode = output.statusCode;
        if (statusCode === 200) {
            //
        } else {
            const errorObj = {
                function: funcName,
                subProcess: this.state.subProcess,
                status: statusCode,
                message: output.body?.message,
                errorObject: accountObj
            };
            this.props.processError(errorObj);
        }

    } catch (error) {
        const errorObj = {
            function: "saveAccountCollection",
            subProcess: this.state.subProcess,
            status: "FETCH_ERROR",
            message: error.message,
            errorObject: this.accountObj
        };
        this.props.processError(errorObj);
    }
}
async saveLoginUser() {
    try {
        const currDateTime = getCurrentDateTime();
        let headers = setTempTokenForFetch(this.state.username, this.state.password);
        const dataObject = {
            role: this.primaryRole,
            accountNbr: this.state.accountNbr,
            securityQuestion: this.state.securityQuestion,
            securityAnswer: this.state.securityAnswer,
            dateAdded: currDateTime.date,
            dateUpdated: currDateTime.date
        };

        const funcName = "saveLoginUser";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        const response = await fetch(uri, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(dataObject)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const output = typeof data === "string" ? JSON.parse(data) : data;
        const statusCode = output.statusCode;
        if (statusCode === 200) {
          //
        } else {
            const errorObj = {
                function: funcName,
                subProcess: this.state.subProcess,
                status: statusCode,
                message: output.body?.message,
                errorObject: dataObject
            };
            this.props.processError(errorObj);
        }

    } catch (error) {
        const errorObj = {
            function: "saveLoginUser",
            subProcess: this.state.subProcess,
            status: "FETCH_ERROR",
            message: error.message,
            errorObject: null
        };
        this.props.processError(errorObj);
    }
}

}

export default CreatePortal;